/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'

const safeDivide = function (numerator, denominator) {
  if (!numerator) { numerator = 0 }
  if (!denominator) { denominator = 0 }
  if (denominator === 0) { return 0 }

  return numerator / denominator
}

// @namespace Model
class Segment extends Base {
  percentOfSegmentingOption (opts) {
    if (opts == null) { opts = {} }
    const numerator = this.get('results_count')
    const denominator = this.collection.responseCount(opts)

    return safeDivide(numerator, denominator)
  }

  percentOfMaxResponseCount (opts) {
    if (opts == null) { opts = {} }
    const numerator = this.get('results_count')
    const denominator = this.collection.maxResponseCount(opts)

    return safeDivide(numerator, denominator)
  }
}

export default Segment
